import React, {useEffect, useState} from 'react';
import BotonVolver from '../components/BotonVolver';
import { PDFDocument } from 'pdf-lib';
import { errorMessage } from '../errorHandler';
import resourcesServices from '../services/resourcesServices';

const RegistroDeObligados = () => {
  const campos_requeridos= [
    {'nombre': 'Nombre'},
    {'apellido': 'Apellido'},
    {'telefono_particula': 'Teléfono Particular'},
    {'email': 'Email'},
    {'cargo1': 'Cargo'},
    {'organismo': 'Organismo'},
    {'nacionalidad': 'Nacionalidad'},
    {'nacim_d': 'Día de nacimiento'},
    {'nacim_m': 'Mes de nacimiento'},
    {'nacim_a': 'Año de nacimiento'},
    {'tipo_doc': 'Tipo de Documento'},
    {'documento': 'Documento'},
    {'estado_civil': 'Estado civil'},
    {'calle_real': 'Calle Real'},
    {'barrio_real': 'Barrio Real'},
    {'localidad_real': 'Localidad Real'},
    {'codigo_postal_real': 'Código Postal Real'},
    {'calle_legal': 'Calle Legal'},
    {'barrio_legal': 'Barrio Legal'},
    {'localidad_legal': 'Localidad Legal'},
    {'codigo_postal_legal': 'Código Postal Legal'},
  ]
  let fileReader;
  const [formularioPDF, setFormularioPDF] = useState({});
  const [step, setStep] = useState(1);
  const [camposFaltantes, setCamposFaltantes] = useState([]);
  const [tramiteFinalizado, setTramiteFinalizado] = useState(false);

  useEffect(() => {
    if(formularioPDF.adjunto){
      fileReader = new FileReader();
      fileReader.readAsArrayBuffer(formularioPDF.adjunto)
      fileReader.onloadend = handleFileReader;
    }
  }, [formularioPDF.adjunto]);

  useEffect(() => {
    if(formularioPDF.campos_formulario_pdfs && formularioPDF.campos_formulario_pdfs.length > 0 && camposFaltantes.length === 0) {
      setStep(2)
    } else {
      setStep(1)
    }

  }, [formularioPDF.campos_formulario_pdfs, camposFaltantes]);


  const handleFileReader = async (e) => {
    const pdfDoc = await PDFDocument.load(fileReader.result, { ignoreEncryption: true });
    const form = pdfDoc.getForm();
    const fields = form.getFields();
    const campos_formulario_pdfs = [];

    const requeridos = []
    fields.forEach(field => {
      const name = field.getName();
      const value = field.getText();

      const requerido = campos_requeridos.map(cr => ((name in cr) && (value === undefined || value === '')) ? cr[name] : false).filter(cr => cr)[0]
      if(requerido){
        requeridos.push(requerido)
      }

      campos_formulario_pdfs.push({
        campo: name,
        valor: value,
      })

    })

    setCamposFaltantes(requeridos)

    setFormularioPDF({...formularioPDF,
      ['campos_formulario_pdfs']: campos_formulario_pdfs
    })
  }

  const campos_basicos = () => {
    return ['nombre', 'apellido', 'email'].map(field => {
      return formularioPDF.campos_formulario_pdfs.map(d => d.campo === field ? `<b>${d.campo}:</b> ${d.valor}` : false).filter(f => f)
    }).join('<br />')
  }

  const guardarUsuario = async () => {
    try {

      const hash = {};
      const copiaFormularioPDF = {...formularioPDF}
      copiaFormularioPDF.campos_formulario_pdfs.forEach(pdf => {
        hash[pdf.campo] = pdf.valor;
      });

      copiaFormularioPDF.fields = hash
      delete copiaFormularioPDF.campos_formulario_pdfs

      await resourcesServices.crearResource('formulario_pdfs', {formulario_pdf: copiaFormularioPDF});

      window.alert("Información actualizada")

      setTramiteFinalizado(true)

    } catch (error) {
      errorMessage(error)
    }
  };


  const handleFormSubmit = (e) => {
    e.preventDefault()
    guardarUsuario()

  }

  const handleFileChange = (e) => {
    const { name, files } = e.target;
    setFormularioPDF({...formularioPDF,
      [name]: files[0]
    })
  };

  return (
    <div>
      <h1>Registro de Obligado <BotonVolver /></h1>
      <div className="card">
        <div className="card-body px-0 pb-2 ms-3 me-3">
          {
            !tramiteFinalizado ? (
              <form onSubmit={handleFormSubmit}>

              <div id="carouselExample" className="carousel slide">
                <div className="carousel-inner">
                  <div className="carousel-item active">
                    <div>
                      Descargue el siguiente formulario interactivo y luego de completarlo, adjúntelo. <br />
                      {/* No sabés como hacerlo ? En el siguiente video te mostramos cómo. <a href="#" className='btn btn-primary' target='_blank'>Ver ayuda</a> */}
                      <br /><a href={`${process.env.REACT_APP_URL}${process.env.PUBLIC_URL}/Planilla-Declaracion-Jurada-de-Datos-200524.pdf`} className='btn btn-success' target='_blank'>Descargar, completar y adjuntar</a>
                      <div className="card mb-3">
                        <div className="card-body">
                          <div className="mb-3">
                            <input
                              placeholder="Adjunte el documento interactivo"
                              className="form-control"
                              onChange={handleFileChange}
                              accept='.pdf'
                              name="adjunto"
                              type="file"
                              id="adjunto" />
                          </div>
                          {
                            formularioPDF.archivoUrl && (
                              <a href={formularioPDF.archivoUrl} className='btn btn-success' target='_blank'>Ver Archivo</a>
                            )
                          }
                        </div>
                        {
                          camposFaltantes.length > 0 && (
                            <div>
                              <h5>Los siguientes campos que no completó en el PDF son obligatorios</h5>
                              {
                                camposFaltantes.join(', ')
                              }
                            </div>
                          )
                        }
                      </div>
                      <button disabled={step===1} className="btn btn-primary mt-3" data-bs-target="#carouselExample" data-bs-slide="next" type="button">Siguiente</button>
                    </div>
                  </div>
                  <div className="carousel-item">
                    <div>
                      {
                        step === 2 && (
                          <>
                          <h5>Recibimos la información</h5>
                          Al clickear el botón <b>Confirmar</b> va a recibir un correo al email que declaró:<br />
                          <div dangerouslySetInnerHTML={{__html: campos_basicos()}} />

                          <button className="btn btn-danger mt-3 me-3" data-bs-target="#carouselExample" data-bs-slide="prev" type="button">Volver</button>
                          <button className="btn btn-primary mt-3" type="submit">Confirmar</button>
                          </>
                        )
                      }
                    </div>
                  </div>
                </div>
              </div>
            </form>
            ) : (
              <div>
                <h5>Trámite finalizado</h5>
              </div>
            )
          }

        </div>
      </div>
    </div>
  );
};
export default RegistroDeObligados;